<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Devices</a></li>
          <li><a>WI-FI</a></li>
        </ul>
      </div>
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">WI-FI Management</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>

        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>

        <div *ngIf="!enableDisablePageLoader" class="wifi-content-container">
          <div class="row row-flex">
            <!-- Wi-Fi Scan Block -->
            <div class="col-lg-6 col-md-12 mb-15">

              <div class="wifi-section-card">
                <div class="section-title">WIFI Scan</div>
                <form [formGroup]="wifiForm" (ngSubmit)="wifiScan()" novalidate>
                  <div class="form-container row">
                    <div class="col-xs-12">
                      <mat-form-field appearance="outline" class="w-100 density-compact">
                        <mat-label>Device Serial No.</mat-label>
                        <mat-select formControlName="serial_number" [(ngModel)]="device.serial_number">
                          <mat-option value="" disabled>Select Device Serial No.</mat-option>
                          <mat-option *ngFor="let dev of devices" [value]="dev.serial_number">{{ dev.serial_number }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="(wifiFormValidation.serial_number.touched || submitted) && wifiFormValidation.serial_number.hasError('required')">
                          <i>Device serial number is required.</i>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-xs-12 text-right">
                      <div class="buttons-div reports_search_div d-inline-block">
                        <div class="transactions-button-container">
                          <button type="submit" class="transaction-submit-button" [disabled]="wifiScanLoading">
                            <span class="icon"><img src="assets/images/New_Icons/search-icon.svg" alt="Search icon"></span>
                            <span class="text">Scan WI-FI</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <div *ngIf="objectlength && objectlength.length > 0" class="table-responsive margin-top-10">
                  <table class="table custom-table">
                    <thead class="thead-light">
                      <tr>
                        <th scope="col">S.No.</th>
                        <th scope="col">Available WIFI Networks</th>
                        <th scope="col">Current IP</th>
                        <th scope="col">Current WIFI</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>
                          <p *ngFor="let x of device.wifi_scan" class="mb-5">{{ x }}</p>
                        </td>
                        <td>{{ device?.ip_address && device?.ip_address[0] }}</td>
                        <td>{{ device?.current_wifi && device?.current_wifi[0] }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Add Wi-Fi Block -->
            <div class="col-lg-6 col-md-12 mb-15">
              <div class="wifi-section-card">
                <div class="section-title">Add WIFI</div>
                <form [formGroup]="addwifiForm" (ngSubmit)="addwifi()" novalidate>
                  <div class="form-container row">
                    <div class="col-xs-12">
                      <mat-form-field appearance="outline" class="w-100 density-compact">
                        <mat-label>Device Serial No.</mat-label>
                        <mat-select formControlName="addserial_number" [(ngModel)]="addDevice.serial_number">
                          <mat-option value="" disabled>Select Device Serial No.</mat-option>
                          <mat-option *ngFor="let dev of devices" [value]="dev.serial_number">{{ dev.serial_number }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="(addWifiFormValidation.addserial_number.touched || addwifisubmitted) && addWifiFormValidation.addserial_number.hasError('required')">
                          <i>Device serial number is required.</i>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-xs-6">
                      <mat-form-field appearance="outline" class="w-100 density-compact">
                        <mat-label>SSID</mat-label>
                        <input matInput formControlName="addssid" [(ngModel)]="addDevice.ssid" autocomplete="off" placeholder="Enter ssid"/>
                        <mat-error *ngIf="(addWifiFormValidation.addssid.touched || addwifisubmitted) && addWifiFormValidation.addssid.hasError('required')">
                          <i>SSID is required.</i>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-xs-6">
                      <mat-form-field appearance="outline" class="w-100 density-compact">
                        <mat-label>Password</mat-label>
                        <input matInput [type]="fieldTextType ? 'text' : 'password'" formControlName="addpassword" [(ngModel)]="addDevice.password" autocomplete="off" placeholder="Enter password"/>
                        <button mat-icon-button matSuffix (click)="toggleFieldTextType()" type="button">
                          <i class="fa" [ngClass]="{'fa-eye-slash': !fieldTextType, 'fa-eye': fieldTextType}"></i>
                        </button>
                        <mat-error *ngIf="(addWifiFormValidation.addpassword.touched || addwifisubmitted) && addWifiFormValidation.addpassword.hasError('required')">
                          <i>Password is required.</i>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-xs-12 text-right">
                      <div class="buttons-div reports_search_div d-inline-block">
                        <div class="transactions-button-container">
                          <button type="submit" class="transaction-submit-button" [disabled]="addWifiLoading">
                            <span class="icon"><img src="assets/images/New_Icons/plus-icon.svg" alt="Plus icon"></span>
                            <span class="text">Add WI-FI</span>
                          </button>
                        </div>
                      </div>
                    </div>


                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


